module.exports = __webpack_public_path__ + "static/media/wallpaper4.0031123b.jpg";